"use strict";

var Session = function () {

  var handleSession = function (section, name, value) {
    $.ajax({
      url: URL,
      type:'POST',
      data: { upaction: 'async', controller: 'system', action: 'session', section: section, name: name, value: value },
      success: function() {
        //console.log('Success');
      },
      error: function(exception){
        console.log('Exeption:' + JSON.stringify(exception));
      }
    });
  };

  var cleanSession = function (section, name, value, form) {
    $.ajax({
      url: URL,
      type:'POST',
      data: { upaction: 'async', controller: 'system', action: 'session', section: section, name: name, value: value },
      success: function() {
        $('#'+form).submit();
      },
      error: function(exception){
        console.log('Exeption:' + JSON.stringify(exception));
      }
    });
  };

  return {
    set: function(section, name, value) {
      handleSession(section, name, value);
    },
    init: function(section, name, value, form) {
      cleanSession(section, name, value, form);
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Session;
}

jQuery(document).ready(function() {
  $('.session-tools').on('click', '.cancel-session', function(e) {
    e.stopPropagation();
    var $this = $(this);
    var section = $this.data("section");
    var form = $this.data("form");
    Session.init(section, 'delete', '1', form);
  });
});